export default str => str.replace(/\s/g, '')
